import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Select, Space, Spin, Table as AntTable, Tabs, Tag } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import DataType from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box, Grid, TextField, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import { apiEndpoints } from '../../../config';
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MComptesRegroup';
import Demande from '../../../Models/McomptesPretEtDecouvert';
import Demande2 from '../../../Models/MComptesOperatSysteme';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import  { ColumnsType } from 'antd/es/table';
import DataPeriod1 from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataPeriod2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import CompteRegroupe from "../../../Models/CompteRegroup";
//import { IconButton, InputAdornment, Paper,  TablePagination, TableRow,TableBody, TableCell, TableContainer, TableHead } from '@mui/material';
import { IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import BlockIcon from '@mui/icons-material/Block';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CheckIcon from '@mui/icons-material/Check';
//import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";
import { Check, CheckCircle } from "@mui/icons-material";
import McomptesCommis from "../../../Models/MComptesCommis";

//pour les commis
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const ComptesCommis = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [DataBranch, SetDataBranch] = useState<McomptesCommis[]>([]);
          const [currentDataBranch, setCurrentDataBranch] = useState<McomptesCommis | null>(null);
            
        const [searchTerm, setSearchTerm] = useState('');
            const [page, setPage] = useState(0); // Page actuelle
             const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
            const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
            const [choix, setChoix] = useState('I');
        
    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Compte de regroupement", value: "PLANCP" },
        { label: " Compte intérêts et commission", value: "IC" },
        { label: " Compte de prêts", value: "TYPEPRET" },
        { label: " Compte produit opération", value: "OPERAT" }
    ]

    //pour la selection de la table
    //let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: Ttable, Colonne1: Nnum, Colonne2: Colon, Colagence: '101', Choix: 22 }
    let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '', Choix: 22 }


    // DECLARATION DES COLONNES DU TABLEAU
    const columns1: ColumnsType<DataType> = [
        {
            title: 'Idplan',
            dataIndex: 'Idplan',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'codage',
            dataIndex: 'codage',
        },
        {
            title: 'cptregpt',
            dataIndex: 'cptregpt',
        }
    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns2: ColumnsType<DataType2> = [
        {
            title: 'CodCom',
            dataIndex: 'CodCom',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'Numcpt',
            dataIndex: 'Numcpt',
        },
        {
            title: 'CptImp',
            dataIndex: 'CptImp',
        },
        {
            title: 'CptDecouv',
            dataIndex: 'CptDecouv',
        },
        {
            title: 'CptTva',
            dataIndex: 'CptTva',
        },
        {
            title: 'CptFrais',
            dataIndex: 'CptFrais',
        },
        {
            title: 'CptTprcm',
            dataIndex: 'CptTprcm',
        },
        {
            title: 'CptTtvaimp',
            dataIndex: 'CptTtvaimp',
        },
        {
            title: 'codage',
            dataIndex: 'codage',
        }

    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns3: ColumnsType<DataType3> = [
        {
            title: 'TYPEPRET',
            dataIndex: 'TYPEPRET',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'IDPLCPTINTIMP',
            dataIndex: 'IDPLCPTINTIMP',
        },
        {
            title: 'IDPLCPTTVAIMP',
            dataIndex: 'IDPLCPTTVAIMP',
        },
        {
            title: 'IDPLCPTINTPAIE',
            dataIndex: 'IDPLCPTINTPAIE',
        },
        {
            title: 'IDPLCPTCOMPTAX',
            dataIndex: 'IDPLCPTCOMPTAX',
        },
        {
            title: 'IDPLCPTPENPAIE',
            dataIndex: 'IDPLCPTPENPAIE',
        },
        {
            title: 'IDPLCPTPROMESS',
            dataIndex: 'IDPLCPTPROMESS',
        },
        {
            title: 'IDPLCPTGARAN',
            dataIndex: 'IDPLCPTGARAN',
        },
        {
            title: 'IDPLCPTINTDOUT',
            dataIndex: 'IDPLCPTINTDOUT',
        },
        {
            title: 'IDPLCPTTVADOUT',
            dataIndex: 'IDPLCPTTVADOUT',
        },
        {
            title: 'IDPLCPTPROVCRDOUT',
            dataIndex: 'IDPLCPTPROVCRDOUT',
        },
        {
            title: 'CODAGE',
            dataIndex: 'CODAGE',
        }

    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns4: ColumnsType<DataType4> = [
        {
            title: 'CODOPE',
            dataIndex: 'CODOPE',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'NUMCPT',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'CODAGE',
            dataIndex: 'CODAGE',
        }
    ];

    useEffect(() => {
        // charge la liste globale des comptes interets/commission (onglet 2)
        chargerListeCm();
    }, []);

        

    function Getselectcli() {
        setData([])
        form.setFieldValue("idplan", "")
        form.setFieldValue("lib_idplan", "")
            SetTtable("PLANCP")
            SetNnum("IDPLAN")
            setColon("LIBELL")
            setColumn(columns1)

        // if (form.getFieldValue("categorie") == "PLANCP") {

        //     SetTtable("PLANCP")
        //     SetNnum("IDPLAN")
        //     setColon("LIBELL")
        //     setColumn(columns1)

        // } else if (form.getFieldValue("categorie") == "IC") {
        //     SetTtable("COMMIS")
        //     SetNnum("CODCOM")
        //     setColon("LIBELL")
        //     setColumn(columns2)
        // } else if (form.getFieldValue("categorie") == "TYPEPRET") {
        //     SetTtable("TYPEPRET")
        //     SetNnum("TYPEPRET")
        //     setColon("LIBELLE")
        //     setColumn(columns3)
        // } else if (form.getFieldValue("categorie") == "OPERAT") {
        //     SetTtable("OPERAT")
        //     SetNnum("CODOPE")
        //     setColon("LIBELL")
        //     setColumn(columns4)
        // } else {
        //     SetTtable("")
        //     SetNnum("")
        //     setColumn("")
        // }
    }

       // Fonction pour convertir un objet avec des clés en majuscules
   
    // 📄 Filtrage des données en fonction du terme de recherche
      const filteredDataBranch = DataBranch.filter((item) =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      // 📄 Pagination gérée par l'AntTable de l'onglet 2

    // ====================================================================
    // NOUVEAU FLOW : comptes interets et commission par code commission
    // Choix du CODCOM -> toutes les agences -> pour chaque agence les 7
    // comptes GL (une ligne COMMIS par agence, sans cote part).
    // Meme logique que les comptes de regroupement.
    // ====================================================================
    // Champs comptes mappes dans COMMIS (prop = nom dans le payload)
    const CHAMPS_CM: { prop: string; label: string }[] = [
        { prop: 'Numcpt',     label: 'Cpte int payé' },
        { prop: 'CptImp',     label: 'Cpte int impayé' },
        { prop: 'CptTva',     label: 'Cpte TVA payé' },
        { prop: 'CptTtvaimp', label: 'Cpte TVA impayé' },
        { prop: 'CptFrais',   label: 'Cpte frais gestion' },
        { prop: 'CptTprcm',   label: 'Cpte TPRCM' },
        { prop: 'CptDecouv',  label: 'Cpte dépassement TPRCM' },
    ];

    // Lit un champ d'une ligne quelle que soit la casse de la cle
    const champCm = (r: any, prop: string) =>
        String(r[prop] ?? r[prop.toUpperCase()] ?? r[prop.charAt(0).toLowerCase() + prop.slice(1)] ?? '');

    const [codcomSel, setCodcomSel] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const [agencesCm, setAgencesCm] = useState<{ codage: string; libelle: string; hasMapping: number }[]>([]);
    // codage -> { comptes par champ, locked (UTIVAL renseigne) }
    const [mapCm, setMapCm] = useState<Record<string, { comptes: Record<string, string>; locked: boolean }>>({});
    const [optComptesCm, setOptComptesCm] = useState<Record<string, { value: string; label: string }[]>>({});
    const [listeCm, setListeCm] = useState<any[]>([]);
    const [loadingListe, setLoadingListe] = useState(false);

    const appelCptCm = async (payload: any): Promise<any> => {
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(`${apiEndpoints.compteRegroup}/GererComptesCommis`, null, {
            headers: { 'CypherGpt': cypher, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        return raw.Value ?? raw;
    };

    const chargerAgencesCm = async () => {
        const codcom = String(form.getFieldValue('CODCOM') ?? '').trim();
        if (!codcom) {
            SweetAlert.fire({ title: 'Code commission requis', icon: 'warning' });
            return;
        }
        setLoading(true);
        try {
            const [resA, resL] = await Promise.all([
                appelCptCm({ Action: 'AGENCES', Codcom: codcom }),
                appelCptCm({ Action: 'LISTE', Codcom: codcom })
            ]);
            setAgencesCm((resA?.Result?.Table ?? []).map((a: any) => ({
                codage: String(a.codage ?? a.CODAGE ?? ''),
                libelle: String(a.libelle ?? a.LIBELLE ?? ''),
                hasMapping: Number(a.hasMapping ?? a.HASMAPPING ?? 0)
            })));
            const map: Record<string, { comptes: Record<string, string>; locked: boolean }> = {};
            (resL?.Result?.Table ?? []).forEach((r: any) => {
                const ag = String(r.codage ?? r.CODAGE ?? '');
                if (!ag) return;
                const comptes: Record<string, string> = {};
                CHAMPS_CM.forEach(f => { comptes[f.prop] = champCm(r, f.prop); });
                map[ag] = { comptes, locked: champCm(r, 'utival').trim() !== '' };
            });
            setMapCm(map);
            setOptComptesCm({});
            setCodcomSel(codcom);
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    // Charge les comptes GL de l'agence a l'ouverture de la liste (une fois)
    const chargerComptesAgenceCm = async (codage: string) => {
        if (optComptesCm[codage]) return;
        try {
            const res = await appelCptCm({ Action: 'COMPTES', Codage: codage });
            const opts = (res?.Result?.Table ?? []).map((c: any) => {
                const nc = String(c.numcpt ?? c.NUMCPT ?? '');
                return { value: nc, label: `${nc} - ${String(c.nomcpt ?? c.NOMCPT ?? '')}` };
            });
            setOptComptesCm(prev => ({ ...prev, [codage]: opts }));
        } catch (e: any) {
            console.log(e);
        }
    };

    const setChampCm = (codage: string, prop: string, v?: string) => {
        setMapCm(prev => {
            const cur = prev[codage] ?? { comptes: {}, locked: false };
            if (cur.locked) return prev;
            return { ...prev, [codage]: { ...cur, comptes: { ...cur.comptes, [prop]: v ?? '' } } };
        });
    };

    const nbChampsCm = (codage: string) =>
        CHAMPS_CM.filter(f => (mapCm[codage]?.comptes[f.prop] ?? '') !== '').length;

    const enregistrerCm = async () => {
        if (!codcomSel) return;
        setLoading(true);
        try {
            const items = agencesCm.map(a => ({
                Codage: a.codage,
                ...Object.fromEntries(CHAMPS_CM.map(f => [f.prop, mapCm[a.codage]?.comptes[f.prop] ?? '']))
            }));
            const res = await appelCptCm({
                Action: 'ENREGISTRER',
                Codcom: codcomSel,
                Utilisateur: Perss.coduti,
                Items: items
            });
            if (res?.StatutCode === 200) {
                SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                chargerAgencesCm();
                chargerListeCm();
            } else {
                SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    const chargerListeCm = async () => {
        setLoadingListe(true);
        try {
            const res = await appelCptCm({ Action: 'LISTE' });
            setListeCm(res?.Result?.Table ?? []);
        } catch (e: any) {
            console.log(e);
        }
        setLoadingListe(false);
    };

    // Charge le codcom de la ligne dans le mapping (onglet 1) : exploration
    const explorerCm = (r: any) => {
        form.setFieldValue('CODCOM', champCm(r, 'codcom'));
        chargerAgencesCm();
        setActiveTab('1');
    };

    const validerLigneCm = (r: any) => {
        const codcom = champCm(r, 'codcom');
        const codage = champCm(r, 'codage');
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider les comptes de l'agence ${codage} (code ${codcom}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptCm({ Action: 'VALIDER', Codcom: codcom, Codage: codage, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeCm();
            if (codcomSel === codcom) chargerAgencesCm();
        });
    };

    const supprimerLigneCm = (r: any) => {
        const codcom = champCm(r, 'codcom');
        const codage = champCm(r, 'codage');
        SweetAlert.fire({
            title: 'Supprimer',
            text: `Supprimer les comptes de l'agence ${codage} (code ${codcom}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptCm({ Action: 'SUPPRIMER', Codcom: codcom, Codage: codage, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeCm();
            if (codcomSel === codcom) chargerAgencesCm();
        });
    };

    // Valide toutes les lignes non validees du codcom affiche (VALIDER, Codcom seul)
    const validerCodcom = () => {
        if (!codcomSel) return;
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider les comptes intérêts/commission du code ${codcomSel} pour toutes les agences ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoading(true);
            try {
                const res = await appelCptCm({ Action: 'VALIDER', Codcom: codcomSel, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoading(false);
            chargerListeCm();
            chargerAgencesCm();
        });
    };

    const colonnesAgencesCm = [
        {
            title: 'Agence', width: 260,
            render: (_: any, r: any) => <span><b>{r.codage}</b> — {r.libelle}</span>
        },
        {
            title: 'Comptes renseignés', width: 160, align: 'center' as const,
            render: (_: any, r: any) => {
                const n = nbChampsCm(r.codage);
                return <Tag color={n > 0 ? 'blue' : 'default'}>{n} / {CHAMPS_CM.length}</Tag>;
            }
        },
        {
            title: 'Statut', width: 110,
            render: (_: any, r: any) => mapCm[r.codage]?.locked
                ? <Tag color='green'>Validé</Tag>
                : <Tag color='orange'>En attente</Tag>
        }
    ];

    // Detail expande : les 7 comptes GL de l'agence
    const detailAgenceCm = (r: any) => {
        const locked = mapCm[r.codage]?.locked === true;
        return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10, padding: '4px 0' }}>
                {CHAMPS_CM.map(f => (
                    <div key={f.prop}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 2 }}>{f.label}</div>
                        <Select
                            size='small'
                            showSearch
                            allowClear
                            optionFilterProp='label'
                            style={{ width: '100%' }}
                            disabled={locked}
                            placeholder='— Choisir un compte GL —'
                            value={mapCm[r.codage]?.comptes[f.prop] || undefined}
                            onDropdownVisibleChange={(open: boolean) => { if (open) chargerComptesAgenceCm(r.codage); }}
                            options={optComptesCm[r.codage] ?? []}
                            onChange={(v?: string) => setChampCm(r.codage, f.prop, v)}
                        />
                    </div>
                ))}
            </div>
        );
    };

    // Filtrage de la liste par le champ recherche
    const filteredListeCm = listeCm.filter((r: any) =>
        Object.values(r).some(v => String(v ?? '').toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const colonnesListeCm = [
        {
            title: 'Code', width: 90,
            sorter: (a: any, b: any) => champCm(a, 'codcom').localeCompare(champCm(b, 'codcom')),
            render: (_: any, r: any) => <b>{champCm(r, 'codcom')}</b>
        },
        {
            title: 'Libellé', width: 160,
            render: (_: any, r: any) => champCm(r, 'libCodcom') || '—'
        },
        {
            title: 'Agence', width: 130,
            sorter: (a: any, b: any) => champCm(a, 'codage').localeCompare(champCm(b, 'codage')),
            render: (_: any, r: any) => <span><b>{champCm(r, 'codage')}</b> — {champCm(r, 'libAgence')}</span>
        },
        // Les 7 comptes GL
        ...CHAMPS_CM.map(f => ({
            title: f.label, width: 130,
            render: (_: any, r: any) => champCm(r, f.prop) || '—'
        })),
        {
            title: 'Statut', width: 110,
            render: (_: any, r: any) => champCm(r, 'utival').trim() !== ''
                ? <Tag color='green'>Validé</Tag>
                : <Tag color='orange'>En attente</Tag>,
            filters: [
                { text: 'Validé', value: 'valide' },
                { text: 'En attente', value: 'attente' }
            ],
            onFilter: (v: any, r: any) => (champCm(r, 'utival').trim() !== '') === (v === 'valide')
        },
        {
            title: 'Créé le', width: 100,
            render: (_: any, r: any) => { const d = champCm(r, 'datcre'); return d ? new Date(d).toLocaleDateString() : '—'; },
            sorter: (a: any, b: any) => champCm(a, 'datcre').localeCompare(champCm(b, 'datcre'))
        },
        {
            title: 'Par', width: 80,
            render: (_: any, r: any) => champCm(r, 'utilis') || '—'
        },
        {
            title: 'Validé le', width: 100,
            render: (_: any, r: any) => { const d = champCm(r, 'datval'); return d ? new Date(d).toLocaleDateString() : '—'; }
        },
        {
            title: 'Par', width: 80,
            render: (_: any, r: any) => champCm(r, 'utival').trim() || '—'
        },
        {
            title: 'Actions', width: 240, fixed: 'right' as const,
            render: (_: any, r: any) => {
                const valide = champCm(r, 'utival').trim() !== '';
                return (
                    <Space size={2} wrap>
                        <Button size='small' onClick={() => explorerCm(r)}>Voir</Button>
                        {!valide && <Button size='small' type='primary' style={{ backgroundColor: '#116599' }} onClick={() => validerLigneCm(r)}>Valider</Button>}
                        {!valide && <Button size='small' danger onClick={() => supprimerLigneCm(r)}>Suppr.</Button>}
                    </Space>
                );
            }
        }
    ];

    // Contenu de l'onglet 2 : meme squelette (.border + .bordure1) que l'onglet 1
    const listeCommis = (
        <Box fontStyle="inherit" className="border" sx={{ width: '85%', minWidth: 0, boxSizing: 'border-box' }}>
            <legend style={{ textAlign: 'center', paddingLeft: 10, borderRadius: 10 }}>
                Liste des comptes intérêts et commission
            </legend>
            <fieldset className="bordure1" style={{ width: '100%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            label="Recherche"
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            size="small"
                            InputLabelProps={{ sx: { fontWeight: 'bold' } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <AntTable
                        size='small'
                        columns={colonnesListeCm as any}
                        dataSource={filteredListeCm}
                        rowKey={(r: any) => `${champCm(r, 'codcom')}-${champCm(r, 'codage')}`}
                        loading={loadingListe}
                        scroll={{ y: 320, x: 'max-content' }}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            pageSizeOptions: [10, 25, 50, 100],
                            showTotal: (t: number) => `${t} ligne(s)`
                        }}
                    />
                </Box>
            </fieldset>
        </Box>
    );

    // --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
      const handleOpenDialog = (DataToEdit: McomptesCommis | null = null) => {
   //alert('modification'+DataToEdit?.UTILIS)
        if (DataToEdit) {
          setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
          
          form.setFieldsValue({...DataToEdit})
          setChoix('U')
         // HandleModif()
         // console.log(DataToEdit)
        } else {
          // Initialiser un nouvel objet avec des valeurs par défaut
        //   setCurrentDataBranch({
        //   NODECE : "string",
        // LECEON : "string",
        // CDETAT : "string",
        // AEGECE : "string",
        // NMURCR : "string",
        // EEDTJE : 0,
        // EETSRL : 0,
        // MTESFD : 0,
        // MTRSFD : 0,
        // EEPEAE : 0,
        // NEDSTE : 0,
        // CLOSPT : 0,
        // CLOSVT : 0,
        // NUMRET : 0,
        // NUMVER : 0,
        // CAIUTI : "0",
        // TYPCAI : "0",
        // DRNOSE : 0,
        // NUMCPT : "0",
        
        //   });
        }
       // setOpenDialog(true);
       // setDialogError(null); // Réinitialiser les erreurs du dialogue
      };

      // --- valide un enregistrement ---
      const handleValidate = (DataToEdit: McomptesCommis | null = null) => {
       setChoix('V')
       if (DataToEdit) { setCurrentDataBranch({ ...DataToEdit })}; // Copie pour l'édition}
      
        if (currentDataBranch?.UTIVAL=== null || currentDataBranch?.UTIVAL=== undefined || currentDataBranch?.UTIVAL==="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
         var comptesCommis: McomptesCommis = {
    IDCODCOM: currentDataBranch?.IDCODCOM || 0,
    CODCOM: currentDataBranch?.CODCOM || '',
    NUMCPT: currentDataBranch?.NUMCPT || '',
    CPTIMP: currentDataBranch?.CPTIMP || '',
    CPTDECOUV: currentDataBranch?.CPTDECOUV || '',
    CPTTVA: currentDataBranch?.CPTTVA || '',
    CPTTTVAIMP: currentDataBranch?.CPTTTVAIMP || '',
    CPTFRAIS: currentDataBranch?.CPTFRAIS || '',
    CPTTPRCM: currentDataBranch?.CPTTPRCM || '',
    CODAGE: currentDataBranch?.CODAGE || '',
    LIBELLE: currentDataBranch?.LIBELLE || '',
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: Perss.coduti,
    DATVAL: Perss.datjour,
    CHOIX: 'V',

            // CodCom: currentDataBranch?.CodCom ||0,
            // idplan: currentDataBranch?.IDPLAN || '',
            // codage:  currentDataBranch?.CODAGE || '',
            // cptregpt : currentDataBranch?.CPTREGPT || '',
            // utilis: currentDataBranch?.UTILIS || '',
            // utival: Perss.coduti || '',
            // datval:Perss.datjour,
            // choix : "V",
            // codcom:"",
            // libelle:currentDataBranch?.NOMCPT || '',
            // nomcpt:"",
            // datcre:currentDataBranch?.DATCRE.toString() || new Date().toDateString(),
         };
       // alert('validation'+DataToEdit?.UTIVAL)
        // alert('validation'+DataToEdit?.UTIVAL)
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        //  CompteReg.choix = choix;
                     
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
       
          let data = Crypter.encrypt(JSON.stringify(comptesCommis));
         if (window.confirm("Confirmer la validation de ce compte de groupe?")) {
         
             alert("yeteooo aaa")
            alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCpCommis,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                loadAllDataBranch()                 
            SweetAlert.fire({})
        // Action de validation ici
       //  console.log("Validé !");
  }
        } else {
          window.alert("Impossible de valider ce compte car il est déjà validé")
        }
      
      };
       // --- valide un enregistrement ---
      const handleDelete = (DataToEdit: McomptesCommis | null = null) => {
       setChoix('D')
     if (DataToEdit) { setCurrentDataBranch({ ...DataToEdit })}; // Copie pour l'édition}
 
        if (currentDataBranch?.UTIVAL!=="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
         var comptesCommis: McomptesCommis = {
     IDCODCOM: currentDataBranch?.IDCODCOM || 0,
    CODCOM: currentDataBranch?.CODCOM || '',
    NUMCPT: currentDataBranch?.NUMCPT || '',
    CPTIMP: currentDataBranch?.CPTIMP || '',
    CPTDECOUV: currentDataBranch?.CPTDECOUV || '',
    CPTTVA: currentDataBranch?.CPTTVA || '',
    CPTTTVAIMP: currentDataBranch?.CPTTTVAIMP || '',
    CPTFRAIS: currentDataBranch?.CPTFRAIS || '',
    CPTTPRCM: currentDataBranch?.CPTTPRCM || '',
    CODAGE: currentDataBranch?.CODAGE || '',
    LIBELLE: currentDataBranch?.LIBELLE || '',
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: currentDataBranch?.UTIVAL || '',
    DATVAL: currentDataBranch?.DATVAL?.toString() || new Date().toDateString(),
    CHOIX: currentDataBranch?.CHOIX || '',


         };
        
          let data = Crypter.encrypt(JSON.stringify(comptesCommis));
         if (window.confirm("Confirmer la suppression de ce compte de groupe?")) {
         
            // alert("yeteooo aaa")
            //alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCpCommis,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            loadAllDataBranch()
           // SweetAlert.fire({})
        // Action de validation ici
        // console.log("Validé !");
  }
        } else {
          window.alert("Impossible de supprimer ce compte car il est déjà validé")
        }
      
      };
    
    
     
        async function loadAllDataBranch() {
          
             setLoading2(true);
            setError(null);
            try {
            
         // console.log(apiEndpoints.bureaux)
          var params = { CodeAgence: Perss.codage , Table: "COMPTESCOMMIS", Colonne1: "CODCOM", Colonne2: "NUMCPT", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
          console.log(params)
          const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
          
          if (data.length!==0)
             {
        // alter(data.result)
          //console.log(data)
          SetDataBranch(normalizeKeysToUppercase(data)); // ou console.log(data)
             }
            }catch (err) {
          console.error("Erreur de chargement:", err);
          setError("Impossible de charger les données .");
         } finally {
          setLoading2(false);
         }
        } ;

    // 🔁 Gestion du changement de page
      const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
      
      };
    
      // 🔁 Gestion du changement de nombre de lignes
      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Revenir à la première page après changement
      };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Génération comptes interets et commission
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    {/*
                      La zone des boutons (.bG) est en absolute a ~89% : ce conteneur
                      reste a gauche (85%), sans absolute ni overflow:hidden (qui
                      coupaient le contenu). minWidth:0 : .tabItem est en flex.
                    */}
                    <Box
                        fontStyle="inherit"
                        className="border"
                        sx={{
                            width: '85%',
                            minWidth: 0,
                            boxSizing: 'border-box',
                        }}
                    >
                        <legend style={{ textAlign: "center", paddingLeft: 10, borderRadius: 10 }} > Comptes intérêts et commission par code commission </legend>
                        <fieldset className="bordure1" style={{ width: '100%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
                            <Grid container spacing={0} alignItems="center">
                                <Grid item xs={12}>
                                    <SearchModal
                                        disabled={false}
                                        width={0}
                                        Titre="Recherche"
                                        label="Code commission"
                                        name="CODCOM"
                                        Taille1={'100%'}
                                        Parametre={searchCommis}
                                        Taille2={'100%'}
                                        form={form}
                                        ExecuteafterSelect1={() => chargerAgencesCm()}
                                    />
                                </Grid>
                            </Grid>
                            {/* Tableau : agences -> 7 comptes GL par agence (ligne expandable) */}
                            <Box sx={{ overflowX: 'auto', width: '100%', marginTop: 2 }}>
                                {agencesCm.length === 0 ? (
                                    <Box style={{ textAlign: 'center', color: '#999', margin: 16 }}>
                                        Choisissez un code commission puis chargez les agences
                                    </Box>
                                ) : (
                                    <>
                                        <AntTable
                                            size='small'
                                            columns={colonnesAgencesCm as any}
                                            dataSource={agencesCm}
                                            rowKey={(r: any) => r.codage}
                                            pagination={false}
                                            scroll={{ y: 400, x: 'max-content' }}
                                            expandable={{
                                                expandedRowRender: (r: any) => detailAgenceCm(r)
                                            }}
                                        />
                                        <Box style={{ marginTop: 12, textAlign: 'right' }}>
                                            <Tag color='geekblue' style={{ marginRight: 8 }}>
                                                Une ligne par agence : dépliez pour renseigner les comptes
                                            </Tag>
                                            <Tag color='orange' style={{ marginRight: 8 }}>
                                                Les lignes validées ne sont pas modifiables
                                            </Tag>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </fieldset>
                    </Box>
                </div>
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <ContactsOutlined />
                    Liste comptes intérêts et commission
                </span>
            ),
            children: <div className='tabItem'>{listeCommis}</div>,
        }
    ];


    function consult() {



    }


    // function Onfinish
    const onFinish = (values: any) => {

        
        var compteCommis: McomptesCommis = values;
    compteCommis.IDCODCOM= currentDataBranch?.IDCODCOM || 0;
    compteCommis.CODCOM= form.getFieldValue("CODCOM") //currentDataBranch?.CODCOM || '';
    compteCommis.NUMCPT= form.getFieldValue("NUMCPT");
    compteCommis.CPTIMP= form.getFieldValue("CPTIMP");
    compteCommis.CPTDECOUV= form.getFieldValue("CPTDECOUV");
    compteCommis.CPTTVA= form.getFieldValue("CPTTVA");
    compteCommis.CPTTTVAIMP= form.getFieldValue("CPTTTVAIMP");
    compteCommis.CPTFRAIS= form.getFieldValue("CPTFRAIS");
    compteCommis.CPTTPRCM= form.getFieldValue("CPTTPRCM");
    compteCommis.CODAGE= Perss.codage;
    compteCommis.LIBELLE = form.getFieldValue("LIBELLE");
    compteCommis.UTILIS=  Perss.coduti;
    compteCommis.DATCRE= Perss.datjour;
    compteCommis.UTIVAL= Perss.coduti;
    compteCommis.DATVAL= Perss.datjour;
    compteCommis.CHOIX= choix;
         
        // CompteReg.idcptregpt = currentDataBranch?.IDCPTREGPT ||0;//CompteReg.idcptregpt;
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        // CompteReg.datcre=Perss.datjour;
        // CompteReg.utival=Perss.coduti;
        // CompteReg.datval=Perss.datjour
        //  CompteReg.choix = choix;                    
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
        // //CompteReg.nomcpt = choix;
        let data = Crypter.encrypt(JSON.stringify(compteCommis));
        
        // ************* pour le consult
        if (sbmit == 'Consult') {
            chargerListeCm();
            // ************* mis a jour  *********************
        } else if (sbmit=='Enreg'){
            // alert("yeteooo aaa")
           // alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCpCommis,
                                headers: {
                                'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            SweetAlert.fire({})
      
        } else if (sbmit=='Add'){
           // alert("modif")
                if (form.getFieldValue("IDPLAN") != "") {
                            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCpCommis,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                        }else {
                            SweetAlert.fire({ title: "Warning", text: "Veuillez remplir le champ Plan Comptable", icon: "warning" })
                        }
        }
    }
  



    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir le champs obligatoire", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir le champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                {/* <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}> */}
                 <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish}  style={{ minWidth: 'auto', maxWidth: 'auto' }}>

                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* Recharge la liste + le mapping du code commission affiche */}
                                <Button size='large' className='bt_add' disabled={loading || loadingListe}
                                    onClick={() => { chargerListeCm(); if (codcomSel) chargerAgencesCm(); }}
                                    type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                {/* Enregistre en masse le mapping du code commission (onglet 1) */}
                                <Button size='large' className='bt_add' onClick={enregistrerCm}
                                    disabled={!codcomSel || agencesCm.length === 0 || loading}
                                    type="ghost" htmlType="button" block>
                                    Enregistrer
                                </Button>
                                {/* Valide toutes les lignes non validees du code affiche */}
                                <Button size='large' className='bt_add' disabled={!codcomSel || loading}
                                    onClick={validerCodcom}
                                    type="ghost" htmlType="button" block>
                                    Valider
                                </Button>
                                <Button size='large' className='bt_add' type="ghost" htmlType="button" block
                                    onClick={() => {
                                        form.resetFields();
                                        setAgencesCm([]);
                                        setMapCm({});
                                        setOptComptesCm({});
                                        setCodcomSel('');
                                        setSearchTerm('');
                                        setActiveTab('1');
                                        setChoix('I');
                                    }}>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" activeKey={activeTab} onChange={setActiveTab} items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ComptesCommis;